module.exports = __webpack_public_path__ + "img/template-icon.a61c3915.svg";